/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect } from 'react';
import Avatar from 'react-avatar';
import { useHistory } from 'react-router-dom';
// Utils
import { getRoleName, validArray, useSetState } from 'utils';
import { lockCanvas } from 'utils/global';
// Auth Context
import { useAuthState } from 'context/AuthContext';
// Assets
import Icon from 'assets/Icon';
// Elements
import Button from 'elements/Button';
import { Drawer } from 'elements/Drawer';
// Components
import AppLinks from './components/AppLinks';
import Profile from './components/Profile';
import ChangeOrganisation from './components/Sites';
// Styles
import styles from './style/navbar.module.css';

interface HistoryProps {
  listen: Function,
}

function NavBar() {
  // Router
  const history = useHistory<HistoryProps>();
  // Auth State
  const { defaultOrganisation } = useAuthState();
  const { roles,
    orgDescription,
    orgRef,
  } = defaultOrganisation || [];
  const {
    employee: {
      firstName,
      lastName,
      organisations,
    },
    user: {
      avatar,
    },
  } = useAuthState();

  // State
  const initialState = {
    drawerActive: false,
  }
  const [state, setState] = useSetState(initialState);
  // User Roles
  const userRoles = validArray(roles) ? roles.map(getRoleName) : [];

  function renderDrawerItem() {
    switch (state.activeDrawer) {
      case 'change-organisation': return (
        <ChangeOrganisation organisations={organisations} />
      );
      case 'app-links': return <AppLinks userRoles={userRoles} />;
      case 'profile': return (
        <Profile
          avatar={avatar || ''}
          employeeName={`${firstName || ''} ${lastName || ''}`}
          orgDescription={orgDescription}
          userRoles={userRoles}
        />
      );
      default: return null;
    }
  }

  const resetNavBar = useCallback(() => {
    function historyCallback() {
      setState({ activeDrawer: false });
    }
    history.listen(historyCallback);
  }, [history, setState]);
  
  useEffect(() => {
    lockCanvas(state.drawerActive);
  }, [state.drawerActive]);

  useEffect(() => {
    if (!orgRef) {
      setState({ activeDrawer: 'change-organisation' });
    }
    resetNavBar();
  }, [resetNavBar, orgRef, setState]);

  return (
    <nav className={styles.container}>
      <ul>
        <li>
          <button
            className={styles.organisation}
            onClick={() => setState({ activeDrawer: 'change-organisation' })}
            type="button"
          >
            { orgDescription || 'Select Organisation' }
          </button>
        </li>
        { validArray(roles) && (
          <li>
            <Button
              btnStyle="primary"
              btnType="icon"
              handler={() => setState({ activeDrawer: 'app-links' })}
              label="Apps"
            >
              <Icon icon="Apps" size={32} fill="white" />
            </Button>
          </li>
        )}
        <li>
          <Button
            btnStyle="primary"
            btnType="icon"
            handler={() => setState({ activeDrawer: 'profile' })}
            label={`${firstName} ${lastName}`}
          >
            <Avatar size="40" round={true} name={`${firstName} ${lastName}`} color="var(--blueberry)" />
          </Button>
        </li>
      </ul>
      <Drawer active={Boolean(state.activeDrawer)} closeHandler={() => setState({ activeDrawer: false })}>
        { renderDrawerItem() }
      </Drawer>
    </nav>
  )
}

export default NavBar;
